export * from './modules/calendar.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/angular-calendar/index.js
// module id = ./src/app/shared/angular-calendar/index.js
// module chunks = main